module.exports = __webpack_public_path__ + "static/media/banner-keyman-2.24e578d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-keyman-2.png
// module id = 1251
// module chunks = 1